"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MeetingDiscountRuleEnum = void 0;
var MeetingDiscountRuleEnum;
(function (MeetingDiscountRuleEnum) {
  /** Скидка не предоставляется */
  MeetingDiscountRuleEnum[MeetingDiscountRuleEnum["none"] = 0] = "none";
  /** Скидка для всех */
  MeetingDiscountRuleEnum[MeetingDiscountRuleEnum["all"] = 1] = "all";
  /** Скидка для новых студентов */
  MeetingDiscountRuleEnum[MeetingDiscountRuleEnum["new_student"] = 2] = "new_student";
  /** Скидка для уже обучавшихся студентов */
  MeetingDiscountRuleEnum[MeetingDiscountRuleEnum["prev_student"] = 3] = "prev_student";
  /** Скидка для постоянных студентов (N занятий) */
  MeetingDiscountRuleEnum[MeetingDiscountRuleEnum["rep_student"] = 4] = "rep_student";
  /** Скидка для студентов в группе */
  MeetingDiscountRuleEnum[MeetingDiscountRuleEnum["group_student"] = 5] = "group_student";
})(MeetingDiscountRuleEnum = exports.MeetingDiscountRuleEnum || (exports.MeetingDiscountRuleEnum = {}));
